module.exports = __webpack_public_path__ + "img/06_map.74452ca4.webp";